import React from 'react';
import ToolIcon from '../components/common/ToolIcon';
import { Droplets } from 'lucide-react';

export const ScheduledServices = [{
        id: 1,
        date: '06 de Abril',
        CalendarDay: 6,
        day: 'Quinta',
        service: 'Manutenção do Jardim',
        time: '14:00 - 16:00',
        status: 'scheduled',
        color: 'green',
        icon: < ToolIcon className = "text-green-600" />
    },
    {
        id: 2,
        date: '08 de Abril',
        CalendarDay: 8,
        day: 'Quinta',
        service: 'Limpeza da Piscina',
        time: '10:00 - 11:30',
        status: 'scheduled',
        color: 'blue',
        icon: < Droplets className = "text-blue-600" />
    },
    {
        id: 3,
        date: '10 de Abril',
        CalendarDay: 10,
        day: 'Quinta',
        service: 'Manutenção do Jardim',
        time: '14:00 - 16:00',
        status: 'scheduled',
        color: 'green',
        icon: < ToolIcon className = "text-green-600" />
    },
    {
        id: 4,
        date: '11 de Abril',
        CalendarDay: 11,
        day: 'Quinta',
        service: 'Poda de Árvores',
        time: '09:00 - 12:00',
        status: 'scheduled',
        color: 'green',
        icon: < ToolIcon className = "text-green-600" />
    },
    {
        id: 5,
        date: '27 de Abril',
        CalendarDay: 27,
        day: 'Quinta',
        service: 'Poda de Árvores',
        time: '09:00 - 12:00',
        status: 'scheduled',
        color: 'green',
        icon: < ToolIcon className = "text-green-600" />
    }
];